module.exports = __webpack_public_path__ + "static/media/image_keyword_03.83669876.webp";